export default function isValidColor(strColor) {
  var style = new Option().style
  style.color = strColor
  return !!style.color
}
